var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'f-nav-wrapper': true,
    'f-nav-main': _vm.main,
    'f-nav-small': _vm.small,
  }},[_c('nav',{class:{
      'wrapper': !_vm.small,
      'flex': true,
      'flex-align-items-center': true
    }},[_c('button',{class:{'mobile-menu-toggle': true, 'is-open': _vm.mobileMenuVisible},attrs:{"id":"mobile-menu-toggle"},on:{"click":function($event){$event.preventDefault();return _vm.handleToggleMenu()}}},[_c('span',[_vm._v(_vm._s(_vm.$t('ui.menu')))])]),_c('ul',{class:{
        'f-nav-list flex mr-auto': true,
        'is-open': _vm.mobileMenuVisible
      }},_vm._l((_vm.filteredItems),function(item,navItemIdx){return _c('li',{key:navItemIdx,staticClass:"f-nav-list-item"},[_c('router-link',{class:{
            'lnk': true,
            'f-nav-link': true,
            'is-completed': item.completed === true,
            'is-not-completed': item.completed === false,
            'text-danger': item.danger
          },attrs:{"data-counter":item.counter,"to":item.to},nativeOn:{"click":function($event){return _vm.handleToggleMenu()}}},[(item.title)?_c('span',{class:{
              'title': true,
              'hidden-mobile': item.titleMobile
            }},[_vm._v(" "+_vm._s(item.title)+" ")]):_vm._e(),(item.titleMobile)?_c('span',{staticClass:"title hidden-desktop-only"},[_vm._v(_vm._s(item.titleMobile))]):_vm._e(),(item.showCounter)?_c('span',{class:{
              'counter': true,
              'counter-danger': item.messagesNotRead
            }},[_vm._v(" "+_vm._s(item.counter)+" ")]):_vm._e()])],1)}),0),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }